import comp from "./SinglePointRubricWithReorderingWrapper";
export default comp;
